import React from 'react';
import { BsFillPlusCircleFill } from 'react-icons/bs';
import { Navigate } from 'react-router-dom';
import { Database } from '../../server/database';
import { Server } from '../../server/server';
import AlertModal from '../modals/AlertModal';
import MessageModal from '../modals/MessageModal';
import QuestionModal from '../modals/QuestionModal';
import SelectAssetModal from '../modals/SelectAssetModal';
import { getAssetImage } from '../util/util';
import './CraftingPage.css'

interface CraftingPageState {
  selectedAsset: string;
  openSelectAssetModal: boolean;
  message: string;
  alert: string;
  question: string;
  questionYes: Function;
}

class CraftingPage extends React.Component<{}, CraftingPageState> {
  constructor(props:{}) {
    super(props);
    this.state = {
      selectedAsset: '',
      openSelectAssetModal: false,
      message: '',
      alert: '',
      question: '',
      questionYes: null
    }

    this.onselectedAsset = this.onselectedAsset.bind(this);
    this.onCloseSelectAssetModal = this.onCloseSelectAssetModal.bind(this);
    this.onCraftMysteryBox = this.onCraftMysteryBox.bind(this);
    this.onCraftMysteryBoxYes = this.onCraftMysteryBoxYes.bind(this);
    this.onCraftCoinPack = this.onCraftCoinPack.bind(this);
    this.onCraftCoinPackYes = this.onCraftCoinPackYes.bind(this);
    this.onQuestionNo = this.onQuestionNo.bind(this);
  }

  onselectedAsset() {
    this.setState({openSelectAssetModal: true});
  }

  onCloseSelectAssetModal(asset:string) {
    this.setState({openSelectAssetModal: false});
    if(asset) {
      let quantity = Server.user.getAssetQuantity(asset);
      if(quantity >= 3)
        this.setState({selectedAsset: asset});
      else
        this.setState({alert: 'You do not have 3 of those!', selectedAsset: ''});
    }
  }

  onCraftMysteryBox() {
    if(this.state.selectedAsset == '') {
      this.setState({alert: 'Select 3 of the same item to craft a Mystery Box!'});
      return;
    }

    let asset = Database.getAsset(this.state.selectedAsset);
    this.setState({question: 'Craft a Mystery Box from three ' + asset.name + '?', questionYes: this.onCraftMysteryBoxYes});
  }

  onCraftMysteryBoxYes() {
    this.setState({message: 'Crafting...', question: ''});
    
    setTimeout(async () => {
      let input = [{id: this.state.selectedAsset, quantity: 3}];
      let output = [{id: 'pack-mystery-box', quantity: 1}];
      let response = await Server.user.craftAsset(input, output);
      if(response.success)
        this.setState({selectedAsset: '', message: '', alert: 'Mystery Box crafted!'});
      else
        this.setState({message: '', alert: response.message});
    }, 500);
  }

  onCraftCoinPack() {
    let landmarks = Database.getAssetsByCategory('collectible');
    for(let i = 0; i < landmarks.length; i++) {
      let owned = (Server.user.getAssetQuantity(landmarks[i].id) > 0);
      if(!owned) {
        this.setState({alert: 'Crafting the Starter Pack requires one of each landmark.'});
        return;
      }
    }

    this.setState({question: 'Craft a Starter Pack using one of each landmark?', questionYes: this.onCraftCoinPackYes});
  }

  onCraftCoinPackYes() {
    this.setState({message: 'Crafting...', question: ''});
    
    setTimeout(async () => {
      let input:any[] = [];
      let landmarks = Database.getAssetsByCategory('collectible');
      for(let i = 0; i < landmarks.length; i++) 
        input.push({id: landmarks[i].id, quantity: 1});

      let output = [{id: 'pack-starter', quantity: 1}];

      let response = await Server.user.craftAsset(input, output);
      
      if(response.success)
        this.setState({selectedAsset: '', message: '', alert: 'Starter Pack crafted!'});
      else
        this.setState({message: '', alert: response.message});
    }, 500);
  }

  onQuestionNo() {
    this.setState({question: ''})
  }

  render() {
    if(!Server.account.isLoggedIn())
      return <Navigate to="/" replace />;

    let mysteryBox = Database.getAsset('pack-mystery-box');
    let coinPack = Database.getAsset('pack-starter');

    let selectedAsset = null;
    if(this.state.selectedAsset != '')
      selectedAsset = Database.getAsset(this.state.selectedAsset);

    let ingredientDiv = <div style={{color: '#ffffff80', fontSize: '18pt', paddingTop: '4px'}}><BsFillPlusCircleFill/></div>;
    if(this.state.selectedAsset != '')
      ingredientDiv = <img style={{width: '70px'}} src={getAssetImage(selectedAsset)}></img>;

    let landmarkDivs:any[] = [];
    let landmarks = Database.getAssetsByTypeAndCategory('collectible', 'landmark');
    for(let i = 0; i < landmarks.length; i++) {
      let owned = (Server.user.getAssetQuantity(landmarks[i].id) > 0);
      let className = 'crafting-page-asset-image' + (!owned ? ' unowned' : '');
      landmarkDivs.push(<img key={i} className={className} src={getAssetImage(landmarks[i])}></img>)
    }
      
    return (
      <div className="crafting-page">
        <div className="crafting-page-panel">
          <div className="crafting-page-asset-panel">
            <img className="crafting-page-asset-image" src={getAssetImage(mysteryBox)}></img>
            <div className="crafting-page-asset-info">
              <div style={{fontSize: '1.1em'}}>{mysteryBox.name}</div>
              <div style={{color: '#ffffffa0'}}>{mysteryBox.description}</div>
            </div>
          </div>
          <div className="crafting-page-recipe-panel">
            <div style={{color: '#ffffffa0', fontSize: '0.9em', textAlign: 'center'}}>
              Select 3 of the same item from inventory:
            </div>
            <div className="crafting-page-recipe-asset-panel">
              <div className="crafting-page-recipe-asset" onClick={this.onselectedAsset}>{ingredientDiv}</div>
              <div className="crafting-page-recipe-asset" onClick={this.onselectedAsset}>{ingredientDiv}</div>
              <div className="crafting-page-recipe-asset" onClick={this.onselectedAsset}>{ingredientDiv}</div>
            </div>
            <div style={{marginBottom: '5px'}}>
              <button onClick={this.onCraftMysteryBox}>Craft Mystery Box</button>
            </div>
          </div>
        </div>

        <div className="crafting-page-panel">
          <div className="crafting-page-asset-panel">
            <img className="crafting-page-asset-image" src={getAssetImage(coinPack)}></img>
            <div className="crafting-page-asset-info">
              <div style={{fontSize: '1.1em'}}>{coinPack.name}</div>
              <div style={{color: '#ffffffa0'}}>{coinPack.description}</div>
            </div>
          </div>
          <div className="crafting-page-recipe-panel">
            <div style={{color: '#ffffffa0', fontSize: '0.9em', textAlign: 'center'}}>
              Craft a Starter Pack with one of each landmark:
            </div>
            <div className="crafting-page-recipe-asset-panel landmarks">
              {landmarkDivs}
            </div>
            <div style={{marginBottom: '5px'}}>
              <button onClick={this.onCraftCoinPack}>Craft Starter Pack</button>
            </div>
          </div>
        </div>

        <MessageModal message={this.state.message} />
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})} />
        <QuestionModal message={this.state.question} onYes={this.state.questionYes} onNo={this.onQuestionNo} />
        <SelectAssetModal open={this.state.openSelectAssetModal} onClose={this.onCloseSelectAssetModal} />
      </div>
    );
  }
}

export default CraftingPage;
